import React, { Component } from 'react';

import { Column, Row } from 'simple-flexbox';
import ManagePSP from './ManagePSP';

class ViewPSP extends Component {
  state = {};

  render() {
    return <Row flexGrow={ 1 } className='module apidata viewClient' vertical='start'>
      <Column flexGrow={ 1 }>
        <ManagePSP pspId={ this.props.match.params.pspId } viewOrEdit={ 1 }/>
      </Column>
    </Row>;
  }
}

export default ViewPSP;